/**
 * Standardized identification source_id prefix and helpers.
 *
 * source_id format: `{prefix}{SEP}{utm_source}{SEP}{utm_medium}{SEP}{utm_campaign}` (exactly 3 parts).
 * We use ASCII Unit Separator (U+001F) as SEP so source/medium/campaign can contain `|`.
 * Used by processor-ingest (phone jobs), processor-metrics (LSA), and source-attribution parser.
 */
export const IdentificationSourceIdPrefix = {
    GoogleAdsPhoneCall: 'google-ads-phone-call',
    CallrailPhoneCall: 'callrail-phone-call',
    CtmPhoneCall: 'ctm-phone-call',
    AlbiDniPhoneCall: 'albi-dni-phone-call',
    PhoneCall: 'phone-call',
    GoogleLsaPhoneCall: 'google-lsa-phone-call',
    VoiceAiCall: 'voice-ai-call',
    MetaLeadForm: 'meta-lead-form',
};
/**
 * Separator for source_id parts. ASCII Unit Separator (U+001F).
 */
export const IDENTIFICATION_SOURCE_ID_SEPARATOR = '\u001f';
export const CTM_LOCAL_SERVICES_ADS_UTM_SOURCE = 'LSA';
export const GOOGLE_LOCAL_SERVICES_ADS_UTM_SOURCE = 'Google Local Services Ads';
export const LOCAL_SERVICES_ADS_UTM_MEDIUMS = ['lsa', 'local_services', 'local services'];
/**
 * Build a full source_id string from prefix and exactly 3 parts.
 * Format: `{prefix}{SEP}{utm_source}{SEP}{utm_medium}{SEP}{utm_campaign}` (SEP = Unit Separator).
 * If fewer than 3 parts are passed, pads with 'phone' and 'none' so all source_ids have the same structure.
 */
export function buildIdentificationSourceId(prefix, parts) {
    const [utm_source = 'unknown', utm_medium = 'phone', utm_campaign = 'none'] = parts;
    const sep = IDENTIFICATION_SOURCE_ID_SEPARATOR;
    return `${prefix}${sep}${utm_source}${sep}${utm_medium}${sep}${utm_campaign}`;
}
/**
 * Prefixes that identify a phone call. Separate from the UTM registry below: membership there only
 * means the id carries source|medium|campaign, which a form submission does too.
 */
export const IDENTIFICATION_SOURCE_ID_PREFIXES_FOR_PHONE_CALL = [
    IdentificationSourceIdPrefix.GoogleAdsPhoneCall,
    IdentificationSourceIdPrefix.CallrailPhoneCall,
    IdentificationSourceIdPrefix.CtmPhoneCall,
    IdentificationSourceIdPrefix.AlbiDniPhoneCall,
    IdentificationSourceIdPrefix.PhoneCall,
    IdentificationSourceIdPrefix.GoogleLsaPhoneCall,
    IdentificationSourceIdPrefix.VoiceAiCall,
];
/**
 * Registry of every prefix that uses the source|medium|campaign format. The source-attribution
 * parser iterates this, so a prefix missing from it is not recognised.
 */
export const IDENTIFICATION_SOURCE_ID_PREFIXES_FOR_UTM = [
    ...IDENTIFICATION_SOURCE_ID_PREFIXES_FOR_PHONE_CALL,
    IdentificationSourceIdPrefix.MetaLeadForm,
];
//# sourceMappingURL=identification-source-id.js.map